import { get } from 'lodash';
import moment from 'moment';

function includesInList(path) {
  return (option, appointment) => {
    const id = get(appointment, path);
    return option.includes(id);
  };
}

const validators = {
  date(option, appointment) {
    const time = get(appointment, 'startTime');
    const localTime = moment(time).toISOString(true);
    return localTime.includes(option);
  },
  locations: includesInList('location.id'),
  services: includesInList('service.id'),
  statuses: includesInList('status.id'),
};

export function validateAppointment(data, filterOptions) {
  const validateResults = Object.keys(filterOptions).reduce((acc, key) => {
    const option = filterOptions[key];
    const validate = validators[key];
    acc.push(validate(option, data));
    return acc;
  }, []);

  return validateResults.every(value => value === true);
}

export function validateAppointmentByDate(data, { date }) {
  return validators.date(date, data);
}



// WEBPACK FOOTER //
// ./src/utils/dashboard/validateAppointmentByFilter.js